import { extendTheme } from '@chakra-ui/react'
import { Button } from './Button'

export const theme = extendTheme({
  colors: {
    brand: {
      100: '#8B2950',
      200: '#8B2950',
      300: '#8B2950',
      400: '#8B2950',
      500: '#8B2950',
      600: '#8B2950',
    },
  },
  components: {
    Button,
  },
})
